/**
 * created by lei lei on 2020/5/31
 * 快捷方式
 */
import React, {Component} from 'react';
import {Col, Row, message, Modal} from "antd";
import taskManage from './img/taskManage.png'
import TopicMange from './img/topicSelect.png'
import AloneActivity from './img/3.png'
import write from './img/write.png'
import web from './img/web.png'
import weChat from './img/weChat.png'
import {
    shrinNavigateStauts, updataNavigateData,
    updateNavigateLevel2Data
} from "../../../../actions";
import {connect} from "react-redux";
import {getMediaList} from "../../../../actions/resourceList";
import {Scrollbars} from "react-custom-scrollbars";
import AddTopic from "../../../../components/resource-list/addTopic";
import {applicationName, permissionCheck} from "../../../../utils";
import * as utils from "../../../../utils";
import openImg from "./img/open.png";
import closeImg from "./img/close.png"
import lock from "./img/lock.png"
import noLock from "./img/noLock.png"
import ShortcutItem from "./ShortcutItem"
import request from "../../../../base/request";

const colNum = 6;

class Shortcuts extends Component {
    static defaultProps = {};
    static propTypes = {};

    defaultMoudules = [
        /* {name: "任务管理", url: "/newsActivityIndex/newsActivityIndex", icon: taskManage, key: 1, type: 'route'},
         {name: "报送选题", url: "/topicSelectManager/topicSelectManager", icon: TopicMange, key: 2, type: 'open'},
         {
             name: "写稿",
             url: "/cm-sites/pms/addContribute/addContributeNews.html?attribute=original&actButtonId=30&isShowMainColumnSetBtn=false",
             icon: write,
             key: 3,
             type: 'open'
         },*/
    ];

    constructor(props) {
        super(props);
        this.state = {
            defaultMoudules: this.defaultMoudules,
            mediaList: [],
            itemWidth: 250,
            openStatus: false,//false 是关闭 显示展开按钮， true 是展开 显示关闭按钮
            lockStatus: false,
            visible: false,
            noAddList: [],

        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        // this.getMediaList();
        this.getUserQuickEntryList();
        this.getUserLockStatus();
        let width = 1440 - 50;
        let itemWidth = width / colNum;
        this.setState({itemWidth})
    }

    // 获取查询当前用户拥有的快捷入口
    getUserQuickEntryList() {
        getUserQuickEntryList(res => {
            let mediaList = [];
            if (res) {
                mediaList = res;
            }
           /* mediaList.push({
                menuName: "报送选题",
                menuUrl: "/topicSelectManager/topicSelectManager",
                menuIcon: TopicMange,
                key: 2,
                menuType: 'open'
            });*/
            mediaList.push({menuName: '添加', menuType: 'add'});
            this.state.defaultMoudules = mediaList;
            this.setState({});
        })
    }

    //获取用户当前锁定状态
    getUserLockStatus() {
        getUserLockStatus(res => {
            //锁定了是有菜单，锁显示，打开收起按钮隐藏
            this.setState({lockStatus: res, openStatus: res ? true : false})
        })
    }

    //获取初始数据
    getMediaList() {
        getMediaList({}, (res) => {
            if (res.status === 200) {
                let list = res.data;
                list.forEach(item => {
                    if (item.type === 1) {
                        this.state.defaultMoudules.push({
                            name: item.name,
                            url: `/website/wangzhan/${item.code}/activityStory`,
                            icon: web,
                            key: this.state.defaultMoudules.length + 1,
                            type: 'route'
                        })
                    } else if (item.type === 2) {
                        this.state.defaultMoudules.push({
                            name: item.name,
                            url: `/view/wechat/originalManuscript/${item.code}`,
                            icon: weChat,
                            key: this.state.defaultMoudules.length + 1,
                            type: 'route'
                        })
                    }
                });
                this.state.defaultMoudules.push({name: '添加', type: 'add'})


            } else {
                this.state.defaultMoudules.push({name: '添加', type: 'add'})
            }
            let width = 1440 - 50;
            let itemWidth = 250;
            /* if (this.state.defaultMoudules.length < 6) {
                 let num = this.state.defaultMoudules.length;
                 let taskManageShow = permissionCheck("pms:newsActiviti:viewAll");//是否展示任务管理
                 if(!taskManageShow){
                     num=num-1
                 }
                 let spaceBlockWidth = (num - 1) * 20;
                 itemWidth = parseInt((width - spaceBlockWidth) / num);
             }*/
            itemWidth = width / colNum;
            this.setState({itemWidth})
        })
    }

    //格式化url
    findUrlData = (url) => {
        let sons;
        let name;
        let stopFind = false;
        let find = (data, level, levelOneBrothers, levelOneName) => {
            if (stopFind)
                return;
            if ((!data.sons || data.sons.length === 0) && (!data.float_ || data.float_.length === 0)) {
                if (data.path === url) {
                    sons = levelOneBrothers;
                    name = levelOneName;
                    stopFind = true;
                }
                return;
            }
            let tempSons = data.float_;
            if (!tempSons || tempSons.length === 0) {
                tempSons = data.sons;
            }
            if (stopFind)
                return;
            tempSons && tempSons.map(item => {
                if (stopFind)
                    return;
                let tempItemSons = item.float_;
                if (!tempItemSons || tempItemSons.length === 0) {
                    tempItemSons = item.sons;
                }
                if (level == 0) {//取第一级的信息
                    find(item, level + 1, tempItemSons, item.name);
                } else {
                    find(item, level + 1, levelOneBrothers, levelOneName);
                }
            })
        };
        find({sons: this.props.navigateData}, 0, null, null);
        return {stopFind, sons, name};
    };

    //页面跳转操作
    gotoPage(item) {
        if (item.menuType === 'open') {
            if (item.menuName === '写稿') {
                let that = this;
                window.openFull(item.menuUrl, "新建稿件", null, {
                    shade: 0.5,
                    area: [parseInt(window.document.body.clientWidth * 0.9) + 'px', parseInt(window.document.body.clientHeight * 0.9) + 'px']
                }, null, function () {

                })
            }
            if (item.menuUrl === "/topicSelectionList/topicSelectionList") {
                this.AddTopic.changeVisible(true)
            }

        } else {
            let {stopFind, sons, name} = this.findUrlData(item.menuUrl);
            if (stopFind) {
                this.props.shrinNavigateStauts();
                this.props.updateNavigateLevel2Data(name, sons);
                this.props.navigateData.forEach(item => {
                    if (item.name === name) {
                        item.check = true;
                        item.status = "down"
                    } else {
                        item.check = false;
                        item.status = "up"
                    }
                });
                this.props.updataNavigateData(this.props.navigateData);
                window.location.hash = item.menuUrl;
                return;
            }
            message.error("跳转地址与系统菜单路由地址配置不符，请尝试重新绑定该快捷方式！");
        }
    }


    render() {
        let taskManageShow = permissionCheck("pms:newsActiviti:viewAll");//是否展示任务管理
        const {openStatus, lockStatus} = this.state;
        return (
            <div className={'Shortcuts StaticMyDeskItemPaddingTop'} style={{width: '100%',}}>
                {/* 右侧悬停按钮*/}
                <div style={{
                    position: 'fixed',
                    right: '100px',
                    padding: 10,
                    borderRadius: 10,
                    background: 'white',
                    top: 100,
                    zIndex: 1000,
                }}>
                    <img src={openStatus ? closeImg : openImg} title={openStatus ? '收起' : '展开'} alt="" onClick={() => {
                        this.setState({openStatus: !openStatus})
                    }} style={{display: lockStatus ? 'none' : 'block',cursor:'pointer'}}/>
                    <div style={{
                        width: 48,
                        height: 48,
                        textAlign: 'center',
                        lineHeight: '48px',
                        display: openStatus ? 'block' : 'none',cursor:'pointer'
                    }}>
                        <img src={lockStatus ? lock : noLock} alt="" onClick={() => {
                            this.lockClick(lockStatus)
                        }}/>
                    </div>

                    <div>
                        {this.state.defaultMoudules&&this.state.defaultMoudules.map((item, index) => {
                            if (index > 4) {
                                return
                            }
                            if (item.menuName === '添加') {
                                return;
                            }
                            if(item.menuName === '写稿'){
                                item.menuIcon=write
                            }
                            return (
                                <div style={{
                                    textAlign: 'center',
                                    height: 68,
                                    lineHeight: '68px',
                                    display: openStatus ? 'none' : 'block',cursor:'pointer'
                                }} key={index} title={item.menuName} onClick={() => {
                                    this.gotoPage(item)
                                }}>
                                    <img style={{width: 48, height: 48}} src={item.menuIcon?item.menuIcon:web}
                                         alt=""/>
                                </div>
                            )
                        })}
                    </div>
                </div>
                {
                    openStatus ? <div style={{position: 'relative'}}>

                        <div style={{width: 1440}}>
                            {
                                this.state.defaultMoudules&&this.state.defaultMoudules.map((item, index) => {
                                    item.itemWidth = this.state.itemWidth;
                                    /*if (!taskManageShow && item.menuName === '任务管理') {
                                        return
                                    }*/
                                    if (lockStatus && item.menuName === '添加') {
                                        return
                                    }
                                    if(item.menuName === '写稿'){
                                        item.menuIcon=write
                                    }
                                    if (!lockStatus && item.menuName === '添加') {
                                        return (
                                            <div key={index} style={{
                                                float: 'left',
                                                marginTop: 10,
                                                marginLeft: index % colNum === 0 ? 0 : 10
                                            }}>
                                                <div style={{display: 'flex'}}>
                                                    <div style={{
                                                        width: this.state.itemWidth,
                                                        background: 'white',
                                                        display: 'flex',
                                                        border: '1px dashed #b2bbd5',
                                                    }}>
                                                        <div onClick={() => {
                                                            this.addClick();
                                                        }} style={{
                                                            cursor: ' pointer',
                                                            height: 160,
                                                            position: 'relative',
                                                            display: 'flex',
                                                            margin: 'auto'
                                                        }}>
                                                            <div style={{}}>
                                                                <div style={{
                                                                    textAlign: 'center',
                                                                    lineHeight: '160px', paddingRight: 10
                                                                }}>
                                                                    <img style={{width: 32, height: 32}}
                                                                         src={'images/newsactivity/news_activity_add.png'}
                                                                         alt=""/>
                                                                </div>
                                                            </div>
                                                            <div style={{
                                                                textAlign: 'center',
                                                                fontSize: 16, lineHeight: '160px', color: '#a4adc8'
                                                            }}>{item.menuName}</div>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                        )
                                    }
                                    //展示的图标
                                    return (
                                        <div key={index} style={{
                                            float: 'left',
                                            marginTop: 10,
                                            marginLeft: index % colNum === 0 ? 0 : 10,cursor:'pointer'
                                        }}>
                                            <ShortcutItem itemWidth={this.state.itemWidth} imgUrl={item.menuIcon?item.menuIcon:web}
                                                          title={item.menuName} itemClick={() => {
                                                this.gotoPage(item)
                                            }}/>
                                        </div>

                                    )
                                })
                            }
                        </div>
                        <div style={{clear: 'both'}}/>

                    </div> : null
                }

                <AddTopic ref={(AddTopic) => {
                    this.AddTopic = AddTopic
                }} relateWriteVisible={false} callBack={(id) => {
                }
                }/>
                {this.renderModal()}
            </div>
        )
    }

    renderModal() {
        return (
            <div>
                <Modal
                    title="添加快捷方式"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={() => {
                        this.setState({visible: false})
                    }}
                    width={782}
                >
                    <div style={{height: 415, background: '#f4f6fc'}}>
                        <Scrollbars>
                            <div style={{height: 415}}>
                                {
                                    this.state.noAddList&&this.state.noAddList.map((item, index) => {
                                        if(item.menuName === '写稿'){
                                            item.menuIcon=write
                                        }
                                        return (
                                            <div key={index} style={{
                                                float: 'left',
                                                marginTop: 10,
                                                marginLeft: 10
                                            }}>
                                                <ShortcutItem imgUrl={item.menuIcon?item.menuIcon:web} title={item.menuName}
                                                              checked={item.checked} itemWidth={this.state.itemWidth}
                                                              itemClick={() => {
                                                                  this.addItemClick(item, index)
                                                              }}/>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </Scrollbars>
                    </div>

                </Modal>
            </div>
        )
    }

    handleOk = () => {
        let params = [];
        this.state.noAddList.forEach(item => {
            if (item.checked) {
                params.push(item)
            }
        });
        /* params= this.state.noAddList[0];*/
        addUserQuickEntry(params, res => {
            message.info('添加成功');
            this.state.visible = false;
            this.getUserQuickEntryList();
            //this.setState({visible: false})
        });

    };

    addClick() {
        getUserNotAddQuickEntryList(res => {
            this.setState({visible: true, noAddList: res})
        });
    };

    //点击添加弹出框的每一项
    addItemClick(item, index) {
        this.state.noAddList[index].checked = !item.checked;
        this.setState({})
    }

    //点击开锁和解锁
    lockClick(lockStatus) {
        if (!lockStatus) {
            //如果是false ，点击后变锁定，锁定按钮后 数据展示，呈现收起状态
            this.state.openStatus = true;
            addLock(res => {
                message.info('锁定成功');
                this.setState({lockStatus: !lockStatus})
            })
        } else {
            openLock(res => {
                message.info('开锁成功');
                this.setState({lockStatus: !lockStatus})
            })
        }
    }
}


function mapStateToProps(state) {
    return {
        navigateData: state.systemReducer.navigateData,
        navigateStatus: state.systemReducer.navigateStatus,
    }
}

function mapStateToMethod(dispatch) {
    return {
        shrinNavigateStauts: function () {
            return dispatch(shrinNavigateStauts());
        },
        updateNavigateLevel2Data: function (title, data) {
            return dispatch(updateNavigateLevel2Data(title, data));
        },
        updataNavigateData: function (data) {
            return dispatch(updataNavigateData(data))
        }
    }
}

export default connect(mapStateToProps, mapStateToMethod)(Shortcuts);
const host = "/cm-sites-" + applicationName() + "/";
//获取快捷方式列表
export const getUserQuickEntryList = (callBack) => {
    request({url:host + "desktopQuickEntry/getUserQuickEntryList", callBack});
};
//获取快捷方式列表
export const getUserNotAddQuickEntryList = (callBack) => {
    request({url:host + "desktopQuickEntry/getUserNotAddQuickEntryList", callBack});
};
//获取用户快捷入口锁定状态
export const getUserLockStatus = (callBack) => {
    request({url:host + "desktopQuickEntry/getUserLockStatus", callBack});
};
//  加锁
export const addLock = (callBack) => {
    request({url:host + "desktopQuickEntry/addLock", method:"post", callBack});
};
//获取用户快捷入口锁定状态
export const openLock = (callBack) => {
    request({url:host + "desktopQuickEntry/openLock", method:"post", callBack});
};
//获取用户快捷入口锁定状态
export const addUserQuickEntry = (params, callBack) => {
    request({url:host + "desktopQuickEntry/addUserQuickEntry", method:"post", callBack});
};